module.exports = __webpack_public_path__ + "static/media/twitter.38688b59.svg";